import InfiniteQueryList from './InifiniteQueryList';

export default InfiniteQueryList;
